module.exports = __webpack_public_path__ + "img/icon-16-drop-down.60cbb12b.svg";